<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<!-- <el-form-item label="客户名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.customerName" placeholder="请输入客户名称"></el-input>
					</el-form-item> -->
					<el-form-item label="地址简称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.addressName" placeholder="请输入地址简称"></el-input>
					</el-form-item>
					<el-form-item label="联系人姓名" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.connName" placeholder="请输入联系人姓名"></el-input>
					</el-form-item>
					<el-form-item label="电话" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.phone" placeholder="请输入联系人电话"></el-input>
					</el-form-item>
		
					<el-form-item label="所属区域:" label-width="80px">
						<el-select clearable filterable v-model="searchInfo.provinceId" placeholder="请选择省"
							@change="provinceFocus">
							<el-option v-for="item in provinceList" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
						<el-select clearable filterable v-model="searchInfo.cityId" placeholder="请选择市"
							@change="cityFcus">
							<el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						<el-select clearable filterable v-model="searchInfo.areaId" placeholder="请选择区"
							@change="districtFcus">
							<el-option v-for="item in districtList" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
				
					<template>
						<el-button type="primary" @click="search">查询</el-button>
						<el-button @click="empty">清空</el-button>
						<el-button type="primary" @click="dialogVisibleFun()">新增地址</el-button>
						<!-- <el-button type="primary" @click="downloadFile"> 导出 </el-button> -->
					</template>
				</el-form>
			</header>
		</div>
		<el-table :data="userList" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column type="index" align="center" width="90" label="#">
			</el-table-column>
			<!-- <el-table-column type="expand">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand">
						<el-form-item label="customerId">
							<span>{{ props.row.customerId }}</span>
						</el-form-item>
						<el-form-item label="地址简称">
						
							<span>{{props.row.addressName}}</span>
						</el-form-item>

						<el-form-item label="联系人姓名">
							<span>{{ props.row.connName }}</span>
						</el-form-item>
						<el-form-item label="联系电话">
							<span>{{ props.row.phone }}</span>
						</el-form-item>
						<el-form-item label="是否默认">
							<span>￥{{ props.row.isDefault==1?'是':'否'}}</span>
						</el-form-item>
						
						<el-form-item label="详细地址">
							<span>{{props.row.province}}{{props.row.city}}{{props.row.area}}{{ props.row.address}}</span>
						</el-form-item>
					</el-form>
				</template>
			</el-table-column> -->
			<!-- <el-table-column prop="customerName" label="客户" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="addressName" label="地址简称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="connName" label="联系人姓名" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="phone" label="联系电话" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- <el-table-column prop="isDefault" label="是否默认" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					
						<span v-if="scope.row.isDefault==0">否</span>
						<span v-if="scope.row.isDefault==1">是</span>
					
				</template>
			</el-table-column> -->
			<el-table-column prop="address" label="详细地址" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span>{{ scope.row.address}}</span>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="longitude" label="经度" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="latitude" label="纬度" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="createTime" label="创建时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id)">编辑</el-button>　
					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>　
					
				</template>　
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px 0px 20px;" background :current-page="goodsList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="goodsList.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 详情查看 -->
		
		<!-- 新增、编辑 -->
		<el-dialog style="float:rigin" :title="dialogVisibleFunName" :closeOnClickModal="false"
			:visible.sync="dialogVisible" width="800px">
			<div class="app-container" style="text-align: center;padding-right:80px">
				<el-form size="medium">
					<div style="display: flex;align-items: center;">
						<!-- <el-form-item label="客户" label-width="120px" style="width:400px">
							<el-select clearable filterable v-model="storeGoodsInfo.customerId" placeholder="请选择客户"
								style="width:100%">
								<el-option v-for="item in unitList" :key="item.id" :label="item.customerName"
								 :value="item.id">
								</el-option>
							</el-select>
						</el-form-item> -->
						<!-- <div style="display: flex;align-items: center;"> -->
							<el-form-item label="地址简称:" label-width="120px">
								<el-input type="text" clearable v-model="storeGoodsInfo.addressName" placeholder="请输入地址简称" 
								style="width:100%;"/>
							</el-form-item>
							
						<!-- </div> -->
						
					</div>
					<div style="display: flex;align-items: center;">
						<el-form-item label="联系人姓名:" label-width="120px" >
							<el-input v-model="storeGoodsInfo.connName" placeholder="请输入联系人姓名" >
							</el-input>
						</el-form-item>
						<el-form-item label="联系电话:" label-width="120px" >
							<el-input v-model="storeGoodsInfo.phone" placeholder="请输入联系电话">
							</el-input>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="所属区域:" label-width="120px">
							<el-select clearable filterable v-model="storeGoodsInfo.province" placeholder="请选择省"
								@change="provinceFocus">
								<el-option v-for="item in provinceList" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
							<el-select clearable filterable v-model="storeGoodsInfo.city" placeholder="请选择市"
								@change="cityFcus">
								<el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
							<el-select clearable filterable v-model="storeGoodsInfo.area" placeholder="请选择区"
								@change="districtFcus">
								<el-option v-for="item in districtList" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</div>
					<el-form-item label="详细地址" label-width="120px" >
						<el-input  type="text" clearable  style="width:600px;" v-model="address" placeholder="请输入详细地址" />
						<el-button icon="el-icon-position" @click="openMap()" type="primary"></el-button>
					</el-form-item>
				
				
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button v-if="dialogVisibleFunName == '新增地址'" type="primary" @click="add">添 加</el-button>
				<el-button v-if="dialogVisibleFunName == '编辑地址'" type="primary" @click="sure">编 辑</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisibleImg" :closeOnClickModal="false">
			<div style="text-align: center;">
				<img width="100%" class="el-upload-list__item-thumbnail" :src="dialogImageUrl" alt="">
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
			</div>
		</el-dialog>
		
	
		
		<el-dialog  :visible.sync="dialogIntroVisible" title="详情">
			<div v-html="storeIntro"></div>
		</el-dialog>
			 <MapSelect ref="ms" @on-select="selectAddress" />	
	</div>
</template>
<script>
	import {
		uploadFile
	} from "@/api/axios.js";
	var urls = uploadFile();
	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
	import MapSelect from '@/components/MapSelect'
	Array.prototype.remove = function(val) {
		var index = this.indexOf(val);
		if (index > -1) {
			this.splice(index, 1);
		}
	};
	export default {
		components: {
			//使用编辑器
			quillEditor,
			MapSelect
		},
		data() {
			return {
				dialogshVisibleck:false,
				storeIntro:'',
				dialogIntroVisible:false,
				czobj:{},
				dialogshenheVisible:false,
				fromDetail:{},
				toDetail:{},
				usertitle:'',
				formbh:{},
				tableData:[],
				tableData1:[],
				innerVisible: false,
				dialogshVisible:false,
				dialogbhVisible:false,
				cImages: [],
				dialogcimg: false,
				dialoguser: false,
				setUpBuyVisible: false,
				goodsImages: '',
				goodsImages1: [],
				orderInfo: {},
				fileList: [],
				fileList1: [],
				storelinks:{},
				storelinks1:[],
				unitList:[],
				dialogVisibleImg: false,
				dialogImageUrl: '',
				httpUrl: urls,
				loading: false,
				goodsList: [{}], //列表
				dialogVisible: false,
				editDialogVisible: false,
				dialogVisibleFunName: '',
				accountList: [],
				dialogVisibleDetails: false,
				detail: '',
				images: [],
				detailType: 0,

				storeGoodsInfo: {
					classId: "",
					isDh: false,
				},
				provinceList: {},
				storeType:'',
				cityList: {},
				districtList: {},
				storeGoodsId: '', //授权用户id
				userList: [],
				ids:'',
				form: {
					refuseReason: ""
				},
				mainFormRules: {
					refuseReason: {
						required: true,
						message: "请输入驳回原因",
						trigger: "blur"
					},
				},
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {},
				mainForm:{},
				address:'',
				latitude:'',
				longitude:''
			};
		},

		methods: {
			// 打开地图弹窗
			openMap() {
				
				this.$refs.ms.show();
				// 根据省市区设置初始值
				this.$refs.ms.setLocationByAddress(this.mainForm.address);
				// 根据经纬度设置初始值
				if(this.storeGoodsInfo.lat){
					this.$refs.ms.setLocationByLatLng(this.storeGoodsInfo.latitude,this.storeGoodsInfo.longitude);
				}else{
					// console.log(this.mainForm.lat,this.mainForm.lng);
				this.$refs.ms.setLocationByLatLng(this.mainForm.lat, this.mainForm.lng);
				}
				
			},
			
			// 地址选择后的回调函数
			selectAddress(address, lat, lng) {
				// console.log(address);
				this.address = address;
				
				
	
			this.latitude=lat
			this.longitude=lng
				
			},
			
			lookxq(storeIntro){
				this.dialogIntroVisible=true
				this.storeIntro=storeIntro
			},
			
		
		
		
			
		
			
		
			addDialogClose() {
				this.storelinks={}
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "商品管理" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			selectisCrontab(e) {
				if (this.storeGoodsInfo.isDh == true) {
					e = false
					this.storeGoodsInfo.isCrontab = false

				} else {
					this.storeGoodsInfo.isCrontab = e

				}
				this.$forceUpdate()
			},
			selectisChoiceness(e) {
				if (this.storeGoodsInfo.isDh == true) {
					e = false
					this.storeGoodsInfo.isChoiceness = false

				} else {
					this.storeGoodsInfo.isChoiceness = e

				}
				this.$forceUpdate()
			},
			handleIsDh(e) {
				if (e == true) {
					this.storeGoodsInfo.isCrontab = false
					this.storeGoodsInfo.isChoiceness = false
				}
			},
			onSuccess1(response, file, fileList) {
				// console.log(res)
				this.goodsImages1.push(response.message);
				// console.log("asda",response,this.goodsImages)
			},
			handleRemove1(file, fileList) {
				if (file.response) {
					this.goodsImages1.remove(file.response.message);
				}
				this.goodsImages1.remove(file.url);
			},
			handlePictureCardPreview1(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			onSuccess(response, file, fileList) {
				// console.log(res)
				this.goodsImages = response.message;
				// console.log("asda",response,this.goodsImages)
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages = ''
				}
				this.goodsImages = ''
			},
			handlePictureCardPreview(file) {

				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			searchStore() {
				let data = {}
				this.$api.supplier(data).then((res) => {
					if (res.state == 'success') {
						//此行代码会出现供应商错误
						// this.storeGoodsInfo.storeId = res.data.list[0].id
						this.accountList = res.data;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			findDetail(string, type) {
				this.dialogVisibleDetails = true;
				this.detailType = type;
				if (type == 1) {
					this.detail = string;

				}
				if (type == 2) {
					this.images = string.split(",");
				}
			},
			storeuserset(id) {
				this.dialoguser = true
				this.ids=id
				
				this.$api.findStoreLinksByStoreId(id).then((res) => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					
					if (res.state == 'success') {
						this.storelinks1=res.data
					} else {
						// console.log(456);
					
						// this.$message.error(res.message);
					}
					// console.log(456);
				})
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				// console.log(this.searchInfo);
				this.getuserList()
			},
			
			dialogVisibleFun(id) {
				this.storeInfo = {}

				this.dialogVisibleFunName = "新增地址"
				this.dialogVisible = true;
				this.storeGoodsInfo = {};
				this.orderInfo={}
				this.goodsImages = '';
				this.fileList = [];
				this.fileList1=[]
				if (id) {
					this.dialogVisibleFunName = "编辑地址"
					// this.searchInfo.id=id
					this.$api.findaddress(id).then((res) => {
							res.data=JSON.parse(this.$decrypt(res.data)).data
						if (res.state == 'success') {
							this.storeGoodsInfo = res.data
							this.address=res.data.address
							this.orderInfo.areaId=res.data.areaId
							this.orderInfo.cityId=res.data.cityId
							this.orderInfo.provinceId=res.data.provinceId
							this.orderInfo.city= res.data.city
							this.orderInfo.province= res.data.province
							this.orderInfo.area= res.data.area
							this.longitude=res.data.longitude
							this.latitude=res.data.latitude
						
						

						}
					})
				}
			},
			//添加商品
			add() {
				
				if (!this.storeGoodsInfo.addressName) {

					this.$message.error('请输入地址简称')
					return
				}
				if (!this.storeGoodsInfo.connName) {

					this.$message.error('请输入联系人姓名')
					return
				}
				if (!this.storeGoodsInfo.phone) {

					this.$message.error('请输入电话')
					return
				}
				
				if (!this.address) {

					this.$message.error('请填写详细地址')
					return
				}
		
				let data = {
					addressName: this.storeGoodsInfo.addressName,
					connName: this.storeGoodsInfo.connName,
					customerId:this.storeGoodsInfo.customerId,
					phone: this.storeGoodsInfo.phone,
				
					username: this.storeGoodsInfo.username,
					areaId: this.orderInfo.areaId,
					cityId: this.orderInfo.cityId,
					provinceId: this.orderInfo.provinceId,
					address: this.address,
					city: this.orderInfo.city,
					province: this.orderInfo.province,
					area: this.orderInfo.area,
					longitude: this.longitude,
					latitude: this.latitude
				}
				
				this.$api.addaddress(this.$encrypt(data)).then((res) => {
					
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible = false;
						this.storeGoodsInfo={}
						this.getuserList();
					} else {
						this.$message.error(res.message);
					}
				})
			},
			//编辑商品
			sure() {
			
				this.storeGoodsInfo.areaId=this.orderInfo.areaId
				this.storeGoodsInfo.cityId=this.orderInfo.cityId
				this.storeGoodsInfo.provinceId=this.orderInfo.provinceId
				this.storeGoodsInfo.address=this.address
				this.storeGoodsInfo.city= this.orderInfo.city
				this.storeGoodsInfo.province= this.orderInfo.province
				this.storeGoodsInfo.area= this.orderInfo.area
				this.storeGoodsInfo.longitude= this.longitude
				this.storeGoodsInfo.latitude= this.latitude
				
			
				
				this.$api.upaddress(this.$encrypt({...this.storeGoodsInfo})).then((res) => {
					
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible = false;
						this.storeGoodsInfo={}
						this.getuserList();
					} else {
						this.$message.error(res.message);
					}
				})

			},
			//删除
			toDelete(row) {
			
				var str = "此操作将删除该地址, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
				
					this.$api.deladdress(row).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getuserList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
				
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getuserList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getuserList()
			},


			getStoreAndUser1(e) {
				// console.log('---', e);
				let obj = {};
				obj = this.userList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				// this.storeGoodsInfo.supplierId = obj.supplierId;
				this.storeGoodsInfo.userId = obj.userId;
				this.$forceUpdate()
				// console.log(this.storeGoodsInfo.username,this.storeGoodsInfo.storeName,this.storeGoodsInfo.userId)
			},

		

			// 点击文件触发
			handlePreview(file) {
				// console.log(file)
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
					return false;
				}
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				}
				return isLt2M, imgStr;
			},
			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			uploadError() {
				this.$message.error("图片上传失败");
			},

			getuserList() {
				let data = {
					pageNum: this.page.pageNum,
					pageSize: 10,
				
					...this.searchInfo
				}
				this.$api.addresslist(this.$encrypt(data)).then(res =>{
					res.data=JSON.parse(this.$decrypt(res.data)).data
					// console.log(res);
					if (res.state == 'success') {
						this.userList = res.data.list;
						this.goodsList=res.data
					}
				})
				
			},
			//查询市
			provinceFocus(e) {
				// console.log(e);
				let obj = {};
				obj = this.provinceList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.province = obj.name
				this.orderInfo.provinceId = obj.id
				this.orderInfo.cityId = ""
				this.cityList = {}
				this.districtList = {}
				if (e) {
					this.$api.findAreas(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
						}
						// console.log(res.data);
					})
				}
			},
			//查询区
			cityFcus(e) {
				// console.log(e);
				let obj = {};
				obj = this.cityList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.city = obj.name
				this.orderInfo.cityId = obj.id
				this.districtList = {}
				if (e) {
					this.$api.findAreas(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
						}
					})
				}

			},
			districtFcus(e) {
				// console.log(e);
				let obj = {};
				obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.area = obj.name
				this.orderInfo.areaId = obj.id
			},
		},
		created() {


			this.getuserList()
			this.$api.findAreas(0).then((res) => {
				if (res.state == 'success') {
					this.provinceList = res.data
				}
			})
			this.$api.findcusomer(this.$encrypt({})).then(res=>{
				res.data=JSON.parse(this.$decrypt(res.data)).data
				this.unitList=res.data
			
			})
		}

	};
</script>

<style lang="less" scoped>
	.el-dialog {
		height: 5000px !important;
	}

	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		width: 100px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}


	.avatar-uploader1 .el-upload {
		border: 1px dashed #d9d9d9;
		width: 200px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
		
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.detailImg img {
		width: 100%;
	}

	.redItem {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
</style>
